/**
 * Implements Wallet overview Page
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AdblockChecker from '../../components/AdblockModal';
import Modal from '../../components/Modal';
import Notifs from '../../components/Notifications';
import TickersDisplayBar from '../../components/TickersDisplayBar';
import Header from '../MainPage/Header';
import WalletBody from './WalletBody';
import WalletBodyMobile from './mobile/WalletBody';
import { actionActivateWalletWatchlist } from '../../actions/wallet_watchlist';
import useDevice from '../MainPage/useMobileDetect';
import { PanelMobile } from '../MainPage/mobile';
import { DEFAULT_URL_PATH } from '../../helpers/constants';

const WalletPage = () => {
  const disaptch = useDispatch();
  const navigate = useNavigate();

  const { isMobile } = useDevice();

  useEffect(() => {
    // Activate watchlist sequence
    disaptch(actionActivateWalletWatchlist());
  }, [disaptch]);

  if (isMobile) {
    return (
      <PanelMobile
        title='Wallet Analyzer'
        onBack={() => navigate(DEFAULT_URL_PATH)}
      >
        <WalletBodyMobile />
        <Modal />
        <Notifs />
      </PanelMobile>
    );
  }

  return (
    <div className='main_page' style={{ height: 'auto' }}>
      <TickersDisplayBar />
      <Header />
      <WalletBody />
      <Modal />
      <Notifs />
      <AdblockChecker />
    </div>
  );
};

export default WalletPage;
